import {Factory} from './Factory'
import Menu from '../EditorComponents/Button/Menu'
export class ButtonFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  object() {
    return {
      id: this.id('button'),
      slug: 'editor-button',
      assets: {
        phone: [],
        tablet: [],
        desktop: []
      },
      background: {
        phone: 'color',
        tablet: 'color',
        desktop: 'color'
      },
      customClasses: [],
      constantClasses: {
        phone: [],
        tablet: [],
        desktop: []
      },
      containerClasses:{
        phone: [],
        tablet: [],
        desktop:[]
      },
      name: 'Button',
    }
  }

  properties() {
    return {
      content: [
        {key: 'link-content', component:'ContentText', text:'text', property:'text'},
        {key: 'text-content', component:'ContentText', text:'link', property:'link'}
      ],
      styles: [
        {key: 'text-alignment', component:'TextAlignmentProperty', class:'containerClasses', except: ['JUSTIFY']},
        {key: 'background-color', component:'BackgroundProperty', only: ['color']},
        {key: 'border', component:'BorderProperty'},
        {key: 'size', component:'SizeProperty'},
        {key: 'rounded', component:'RoundedProperty'},
        {key: 'shadow', component:'ShadowProperty'},
        {key: 'text-color', component:'TextColorProperty'},
        {key: 'font-weight', component: 'FontWeightProperty'},
        {key: 'button-margin', component:'MarginProperty', class:'containerClasses'},
      ],
      advanced: [
        {key: 'element-id', component: 'ElementId'},
        {key: 'custom-classes', component: 'CustomClasses'},
        {key: 'custom-styles', component: 'CustomStyles'},
      ],
      menu: Menu
    }
  }
}
